//import * as util from './util.ts'
// react-ga
import * as log from './appLogger';
import { Config } from '../../data/Config';
import * as wording from './wording';

var GA_ID_DEV = '';
var isGACreated = false;

var gaPrefix = '/acquisition/Home-5G-Broadband';
var sendPath = '';
var pageName = '';
var langString = '';

/*
/en/acquisition/Home-5G-Broadband/homepage
/en/acquisition/Home-5G-Broadband/plan-selection-page

 **/

declare global {
	interface Window {
		ga: any;
	}
}

function isEnabled() {
	return Config.enableGA;
}

//call GA create. GA lib is included in index.js
function initGA() {
	if (isEnabled() && !isGACreated) {
		window.ga = window.ga || {};
		GA_ID_DEV = Config.gaId;
		log.it('GA', 'init GA');
		window.ga('create', GA_ID_DEV, 'auto');
		isGACreated = true;
	}
}

export function logPageView(name: string) {
	window.ga = window.ga || {};
	log.it('GA', '[logPageView]' + name);

	//Check is environment enable GA
	if (!isEnabled()) {
		return;
	}
	initGA();
	//sendPath = gaPrefix + name;

	let useToSendPageview = false;
	// to avoid /a/ to trigger send pageview

	langString = wording.getLang() === wording.ENGLISH ? '/en' : '/tc';

	if (name.includes('/a1')) {
		pageName = '/homepage';
		useToSendPageview = true;
	} else if (name.includes('/a2')) {
		pageName = '/plan-selection-page';
		useToSendPageview = true;
	}
	sendPath = langString + gaPrefix + pageName;

	//Log page view.
	if (useToSendPageview) {
		log.it('GA', '[logPageView] ga send:' + sendPath);
		window.ga('send', 'pageview', sendPath);
	}
}
